import{useState as o}from"react";var e=function(e){void 0===e&&(e=!1);var r=o(e),t=r[0],n=r[1];return[t,function(o){var e="boolean"==typeof o?o:!t;n(e),document.body.style.overflow=e?"hidden":""}]};export{e as default};
//# sourceMappingURL=index.js.map
